import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
} from "@mui/material";
import { isCompany } from "../../Config/isCompany";
import NotFoundPage from "../../Pages/NotFoundPage";

const AppliedUsers = () => {
  const { post_id } = useParams(); // ID parametresi alınır
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate()
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          `https://kariyer.biyomed.net/api/posts/applied-users/${post_id}`,
          { withCredentials: true }
        );
        setUsers(response.data.users || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, [post_id]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleClick = async (userid) => {
    try {
      // Kullanıcının başvurusunu görüntülendi olarak işaretle
      await axios.put(
        `https://kariyer.biyomed.net/api/posts/viewed`, 
        { user_id: userid, post_id: post_id }, 
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Error updating viewed status:", error);
    }
  
    // Kullanıcı detay sayfasına yönlendirilir
    navigate(`/applied-user-details/${userid}`);
  };
  

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (<>{isCompany ?    <div style={{ padding: "10px" , marginBottom:170}}>
    {users.length === 0 ? <p style={{padding:100, marginTop:100, fontSize:"50px"}}> Bu ilana henüz başvuran yok </p> : <><h2>Başvuran Kullanıcılar</h2>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>Ad</TableCell>
              <TableCell>Soyad</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Telefon</TableCell>
              <TableCell>Aksiyon</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((user, index) => (
                <TableRow key={user.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{user.first_name}</TableCell>
                  <TableCell>{user.last_name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.phone}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleClick(user.id)}
                    >
                      Profili Gör
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={users.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Satır Sayısı"
      /></>}

  </div> :<NotFoundPage/> }</>

  );
};

export default AppliedUsers;
